{
    "translation": {
        "common": {
            "save": "Speichern",
            "abort": "Abbrechen",
            "back": "Zurück",
            "close": "Schließen",
            "new": "Neu",
            "nothingSelected": "Nichts ausgewählt",
            "project": "Projekt",
            "delete": "Löschen",
            "deleted": "Gelöscht",
            "active": "Aktiv",
            "yes": "Ja",
            "no": "Nein",
            "youSure": "Sind Sie sicher?",
            "noReturn": "Diese Aktion kann nicht rückgängig gemacht werden.",
            "search": "Suche",
            "homepage": "Startseite",
            "trackings": "Trackings",
            "user": "Benutzer",
            "projects": "Projekte",
            "reports": "Berichte",
            "admin": "Admin",
            "holidays": "Feiertage",
            "globalSettings": "Globale Einstellungen",
            "businesses": "Unternehmen",
            "workingTimeModel": "Arbeitszeitmodelle",
            "about": "Über",
            "help": "Hilfe",
            "settings": "Einstellungen",
            "signOut": "Abmelden",
            "edit": "Bearbeiten",
            "from": "Von",
            "to": "Bis",
            "name": "Name",
            "description": "Beschreibung",
            "start": "Start",
            "stop": "Stopp",
            "noTrackingStarted": "Keine Zeiterfassung gestartet",
            "trackingWithoutTime": "Zeiterfassung ohne Zeit gestartet",
            "noProject": "Kein Projekt",
            "filter": "Filter",
            "toFilter": "Filtern",
            "view": "Betrachten",
            "now": "Jetzt",
            "durationSum": "Summe: {{value, duration}}",
            "today": "Heute",
            "login": "Anmelden",
            "noTrackings": "Keine Trackings",
            "reload": "Neu laden",
            "ui": {
                "systemPreferenceMode": "System",
                "darkMode": "Dunkler Modus",
                "lightMode": "Heller Modus"
            },
            "timeOnly": {
                "duration": "{{value, duration}}",
                "short": "{{value, datetime(hour: numeric; minute: numeric)}}"
            },
            "dateOnly": {
                "short": "{{value, datetime(year: numeric; month: numeric; day: numeric)}}",
                "yearMonth": "{{value, datetime(year: numeric; month: numeric)}}",
                "yearOnly": "{{value, datetime(year: numeric)}}"
            },
            "actions": "Aktionen",
            "hours": "Stunden",
            "allProjects": "Alle Projekte",
            "statistics": "Statistiken",
            "noWorkingTimeModelAssigned": "Sie haben kein Arbeitszeitmodell zugewiesen"
        },
        "landingPage": {
            "welcome": "Willkommen im Time Tracking!",
            "pleaseAuthenticate": "Bitte melden Sie sich an um fortzufahren."
        },
        "todaysTrackings": {
            "title": "Heutige Zeitaufzeichnungen"
        },
        "closedTrackings": {
            "title": "Manuelle Änderungen erforderlich"
        },
        "bookedTime": {
            "title": "Verbuchte Zeit",
            "day": "Tag",
            "week": "Woche",
            "month": "Monat",
            "year": "Jahr"
        },
        "editTrackings": {
            "day": "Tag",
            "start": "Start",
            "end": "Ende",
            "typeOfTracking": "Art der Zeitaufzeichnung",
            "publicDescription": "Öffentliche Beschreibung",
            "internalDescription": "Interne Beschreibung",
            "fromBeforeTo": "Muss vor Endzeitpunkt liegen.",
            "askYourAdmin": "Bitte wenden Sie sich an einen Administrator",
            "trackingCreateAtStartOfWTM": "Das Tracking wurde zu Beginn des Tages erstellt."
        },
        "trackings": {
            "filters": {
                "fromTo": "{{from, datetime(year: numeric; month: numeric; day: numeric)}} - {{to, datetime(year: numeric; month: numeric; day: numeric)}}",
                "fromUntilToday": "{{from, datetime(year: numeric; month: numeric; day: numeric)}} - Heute",
                "fromInFuture": "Ab {{from, datetime(year: numeric; month: numeric; day: numeric)}}",
                "todayUntilTo": "Heute - {{to, datetime(year: numeric; month: numeric; day: numeric)}}",
                "toInPast": "Bis {{to, datetime(year: numeric; month: numeric; day: numeric)}}"
            },
            "breakBetweenTrackings": "{{value, duration}} Pause"
        },
        "projects": {
            "urlEdit": "Admin / Projekte / Bearbeiten",
            "urlCreate": "Admin / Projekte / Neu",
            "urlIndex": "Admin / Projekte",
            "edit": "Projekt bearbeiten",
            "create": "Projekt erstellen",
            "color": "Farbe",
            "name": "Projektname",
            "description": "Beschreibung",
            "startDate": "Startdatum",
            "endDate": "Enddatum",
            "valid": "Gültig",
            "externalReference": "Externe Referenz",
            "colorSelection": "Farbauswahl",
            "trackingType": "Art der Zeitaufzeichnung",
            "deleted": "Gelöscht",
            "startWithProject": "Mit Projekt starten",
            "switchProject": "Projekt wechseln",
            "users": "Benutzer",
            "selectProject": "Projekt auswählen"
        },
        "snackbar": {
            "successCreateBusiness": "Unternehmen erfolgreich erstellt.",
            "successCreateProject": "Projekt erfolgreich angelegt.",
            "successCreateUser": "Benutzer erfolgreich angelegt.",
            "successCreateWorkingTimeModel": "Arbeitszeitmodell erfolgreich angelegt.",
            "successDuplicateWorkingTimeModel": "Das Arbeitszeitmodell erstellen Formular wurde vorausgefüllt.",
            "successEditProject": "Projekt erfolgreich bearbeitet.",
            "successEditUser": "Benutzer erfolgreich bearbeitet.",
            "successEditWorkingTimeModel": "Arbeitszeitmodell erfolgreich bearbeitet.",
            "successDeleteWorkingTimeModel": "Arbeitszeitmodell erfolgreich gelöscht.",
            "successDeleteProject": "Projekt erfolgreich gelöscht.",
            "successDeleteBusiness": "Unternehmen erfolgreich gelöscht.",
            "successDeleteUser": "Benutzer erfolgreich gelöscht.",
            "successAbortTracking": "Zeitaufzeichnung erfolgreich abgebrochen.",
            "successStartTracking": "Zeitaufzeichnung erfolgreich gestartet.",
            "successSwitchTracking": "Zeitaufzeichnung erfolgreich gewechselt.",
            "successStopTracking": "Zeitaufzeichnung erfolgreich beendet.",
            "successEditDescriptionTracking": "Beschreibung erfolgreich aktualisiert.",
            "successEditTrackings": "Zeitaufzeichnungen wurden erfolgreich aktualisiert.",
            "successEditBusiness": "Unternehmen erfolgreich bearbeitet.",
            "successSetGlobalSettings": "Globale Einstellungen erfolgreich gesetzt.",
            "successGenerateReport": "Bericht erfolgreich erstellt.",
            "successDownloadReport": "Bericht erfolgreich heruntergeladen.",
            "successUpdatePassword": "Passwort erfolgreich geändert.",
            "successCopyReportData": "Bericht erfolgreich kopiert.",
            "failedCreateBusiness": "Unternehmen konnte nicht angelegt werden.",
            "failedCreateProject": "Projekt konnte nicht angelegt werden.",
            "failedCreateUser": "Benutzer konnte nicht angelegt werden.",
            "failedCreateWorkingTimeModel": "Arbeitszeitmodell konnte nicht angelegt werden.",
            "failedEditProject": "Projekt konnte nicht bearbeitet werden.",
            "failedEditUser": "Benutzer konnte nicht bearbeitet werden.",
            "failedEditBusiness": "Unternehmen konnte nicht bearbeitet werden.",
            "failedEditWorkingTimeModel": "Arbeitszeitmodell konnte nicht bearbeitet werden.",
            "failedDeleteWorkingTimeModel": "Arbeitszeitmodell konnte nicht gelöscht werden.",
            "failedDeleteProject": "Projekt konnte nicht gelöscht werden.",
            "failedDeleteBusiness": "Unternehmen konnte nicht gelöscht werden.",
            "failedAbortTracking": "Zeitaufzeichnung konnte nicht abgebrochen werden.",
            "failedStartTracking": "Zeitaufzeichnung konnte nicht gestartet werden.",
            "failedSwitchTracking": "Zeitaufzeichnung konnte nicht gewechselt werden.",
            "failedStopTracking": "Zeitaufzeichnung konnte nicht beendet werden.",
            "failedEditDescriptionTracking": "Beschreibung konnte nicht aktualisiert werden.",
            "failedEditTrackings": "Zeitaufzeichnungen konnten nicht aktualisiert werden.",
            "failedSetGlobalSettings": "Globale Einstellungen konnten nicht gesetzt werden.",
            "failedGenerateReport": "Bericht konnte nicht erstellt werden.",
            "failedDownloadReport": "Bericht konnte nicht heruntergeladen werden.",
            "failedUpdatePassword": "Passwort konnte nicht geändert werden.",
            "failedSetUserSettings": "Die Benutzer Einstellung konnte nicht gesetzt werden.",
            "failedValidation": "Es gibt Validierungsfehler."
        },
        "user": {
            "initials": "Initialien",
            "firstName": "Vorname",
            "lastName": "Nachname",
            "email": "E-Mail",
            "emailConfirmed": "E-Mail bestätigt",
            "userName": "Benutzername",
            "role": "Rolle",
            "currentPassword": "Aktuelles Passwort",
            "password": "Passwort",
            "passwordRepeat": "Passwort wiederholen",
            "urlUser": "Admin / Benutzer",
            "urlEdit": "Admin / Benutzer / Bearbeiten",
            "urlNew": "Admin / Benutzer / Neu",
            "edit": "Benutzer bearbeiten",
            "create": "Benutzer erstellen",
            "businessLocations": "Unternehmensstandorte"
        },
        "validation": {
            "workingTimeModelIdRequired": "Arbeitszeitmodell darf nicht leer sein.",
            "workingTimeModelValidFromRequired": "Von darf nicht leer sein.",
            "workingTimeModelValidUntilRequired": "Bis darf nicht leer sein.",
            "workingTimeModelOverlapFrom": "Von überschneidet sich mit einem anderen Arbeitszeitmodell.",
            "workingTimeModelOverlapUntil": "Bis überschneidet sich mit einem anderen Arbeitszeitmodell.",
            "passwordsMustMatch": "Passwörter müssen übereinstimmen.",
            "workTimeStartAtRequired": "Wenn der Startpunkt ausgefüllt ist, muss auch die Arbeitszeit ausgefüllt sein.",
            "workTimeDurationRequired": "Wenn die Arbeitszeit ausgefüllt ist, muss auch der Startpunkt ausgefüllt sein.",
            "trackingTypeRequired": "Es muss ein Zeitaufzeichnungs Typ ausgewählt werden.",
            "selectionRequired": "Es muss etwas ausgewählt werden.",
            "required": "Darf nicht leer sein.",
            "endBeforeStart": "Ende darf nicht vor dem Start liegen.",
            "overlappingEntries": "Überlappt sich mit anderem Eintrag",
            "startOutOfBounds": "Start liegt außerhalb der erlaubten Zeit.",
            "endOutOfBounds": "Ende liegt außerhalb der erlaubten Zeit.",
            "emptyArrayExpected": "Leeres Array erwartet.",
            "nonNullValueExpected": "Nicht-Null-Wert erwartet.",
            "timeSection": "Der Zeitabschnitt des Datums muss 0 sein.",
            "date_must_be_after_or_equal": "Muss nach oder gleich {date} sein.",
            "date_must_be_before_or_equal": "Muss vor oder gleich {date} sein."
        },
        "dateTime": {
            "dayOfWeek": "Wochentag",
            "start": "Startpunkt",
            "duration": "Arbeitszeit",
            "noDays": "Keine Tage",
            "monday": "Montag",
            "tuesday": "Dienstag",
            "wednesday": "Mittwoch",
            "thursday": "Donnerstag",
            "friday": "Freitag",
            "saturday": "Samstag",
            "sunday": "Sonntag"
        },
        "workingTimeModel": {
            "urlEdit": "Admin / Arbeitszeitmodelle / Bearbeiten",
            "urlCreate": "Admin / Arbeitszeitmodelle / Neu",
            "urlIndex": "Admin / Arbeitszeitmodelle",
            "edit": "Arbeitszeitmodell bearbeiten",
            "create": "Arbeitszeitmodell erstellen",
            "noTrackingBefore": "Keine Trackings vor",
            "noTrackingAfter": "Keine Trackings nach",
            "pauseAfter": "Pause spätestens nach",
            "pauseDuration": "Pause Mindestlänge",
            "maximumWorkTimePerDay": "Maximale Arbeitszeit pro Tag",
            "allowOverlappingTrackings": "Trackings dürfen sich überlappen",
            "assignableFrom": "Zuweisbar ab",
            "assignableUntil": "Zuweisbar bis",
            "assignableFromAfterUntil": "Zuweisbar von darf nicht nach Zuweisbar bis liegen.",
            "duplicate": "Duplizieren",
            "userWorkingTimeModelsAutoEnded": "Das Ende der Arbeitszeitmodell zuweisung wurde für folgende Benutzer gesetzt:"
        },
        "holidays": {
            "urlIndex": "Admin / Feiertage"
        },
        "settings": {
            "languages": {
                "german": "Deutsch",
                "english": "Englisch"
            },
            "pageTitle": "Einstellungen",
            "language": "Sprache",
            "commonTab": "Allgemein",
            "passwordTab": "Passwort",
            "timeProgressToDate": "Verbuchte Zeit bis heute berechnen.",
            "timeProgressToDateHelper": "Die zu arbeitende Zeit wird bis zum heutigen Tag berechnet und nicht bis zum Ende des gewählten Zeitraums.",
            "useCalendarForTrackings": "Kalender statt einer Liste verwenden.",
            "useCalendarForTrackingsHelper": "Verwendet für die Übersicht aller Trackings einen Kalender anstatt einer Liste."
        },
        "business": {
            "name": "Unternehmensname",
            "urlEdit": "Admin / Unternehmen / Bearbeiten",
            "urlNew": "Admin / Unternehmen / Neu",
            "urlIndex": "Admin / Unternehmen",
            "edit": "Unternehmen bearbeiten",
            "create": "Unternehmen erstellen",
            "business": "Unternehmen",
            "location": "Standorte",
            "locationName": "Standortname",
            "noLocations": "Keine Standorte",
            "addLocation": "Standort hinzufügen",
            "locationCount": "Standortanzahl"
        },
        "globalSettings": {
            "url": "Admin / Globale Einstellungen",
            "title": "Globale Einstellungen",
            "primaryColorLight": "Primäre Farbe Helles Schema",
            "secondaryColorLight": "Sekundäre Farbe Helles Schema",
            "primaryColorDark": "Primäre Farbe Dunkles Schema",
            "secondaryColorDark": "Sekundäre Farbe Dunkles Schema",
            "uploadLogo": "Logo hochladen"
        },
        "navigationFormBlocker": {
            "areYouSure": "Sind sie sicher das sie Seite verlassen wollen?",
            "unsavedChangesLost": "Ungespeicherte Änderungen gehen dadurch verloren."
        },
        "statistics": {
            "hoursPerProject": "Projektstunden",
            "hoursInTimespan": "Stunden in Auswahl",
            "compareHoursToWorkingTimeModel": "Vergleich Arbeitszeit Soll/Ist",
            "noData": "Keine Daten vorhanden",
            "workedTimeHours": "{{value}} $t(common.hours) gearbeitet",
            "differenceBetweenWorkedTimeAndWTMHoursPositive": "{{value}} $t(common.hours) mehr als das Arbeitszeitmodell gearbeitet",
            "differenceBetweenWorkedTimeAndWTMHoursNegative": "{{value}} $t(common.hours) weniger als das Arbeitszeitmodell gearbeitet"
        },
        "reports": {
            "reportsTitle": "Berichte",
            "reportsUrl": "Admin / Berichte",
            "outputFormat": "Ausgabeformat",
            "csvExportQuoteCharacter": "Anführungszeichen im Export",
            "csvExportSeperatorCharacter": "Trennzeichen im Export",
            "csvExportQuoteCharacterNone": "Keine",
            "generateReport": "Bericht erstellen",
            "downloadFile": "Herunterladen",
            "trackings": {
                "projects": "Projekte",
                "users": "Benutzer",
                "round": "Zeit runden",
                "combineAdjacentTrackings": "Benachbarte Trackings kombinieren",
                "joinDescriptionCharacter": "Trennzeichen für kombinierte Beschreibungen benachbarter Trackings",
                "includeDurationColumn": "Dauer in Ausgabe inkludieren",
                "includeDescriptionColumn": "Beschreibung in Ausgabe inkludieren",
                "projectAndUserIdsCantBothBeEmpty": "Projekte und Benutzer können nicht beide leer sein. Zumindest muss ein Projekt oder ein Benutzer ausgewählt werden."
            },
            "table": "Tabelle",
            "raw": "Rohdaten"
        },
        "notifications": {
            "noNotifications": "Keine Benachrichtigungen",
            "trackingAborted": "Tracking wurde abgebrochen",
            "trackingStartEnd": "{{start, datetime(year: numeric; month: numeric; day: numeric; hour: numeric; minute: numeric)}} - {{end, datetime(hour: numeric; minute: numeric)}}"
        },
        "pwa": {
            "offlineReady": "Das TimeTracking wurde erfolgreich installiert.",
            "offlineReadyExplanation": "Dadurch starte die App schneller als zuvor.",
            "newVersion": "Eine neue Version vom TimeTracking ist verfügbar. Wollen Sie die neue Version jetzt verwenden?",
            "newVersionExplanation": "Damit sie verwendet werden kann, muss die Seite neu geladen werden."
        },
        "errorComponent": {
            "title": "Es gab einen Fehler.",
            "subTitle": "Bitte leiten Sie die folgende Informationen weiter.",
            "reload": "Neu laden"
        },
        "onboarding": {
            "welcomeLabel": "Willkommen",
            "welcomeText": "Klick auf 'Weiter' um fortzufahren.",
            "documentWorkLabel": "Dokumentiere deine Arbeit",
            "documentWorkText": "Behalte den Überblick über alle deine Aufzeichnungen und ordne sie nach Projekten.",
            "stayConcentratedLabel": "Bleibe konzentriert",
            "stayConcentratedText": "Automatisiere die Zeitaufzeichnung und konzentriere dich auf wichtige Aufgaben.",
            "next": "Weiter",
            "prev": "Zurück",
            "finish": "Fertig"
        },
        "about": {
            "pageTitle": "Über das TimeTracking",
            "backendAssemblyVersions": "Das Backend basiert auf dem commit {{commit}} und läuft mit folgenden Teilen:",
            "frontendVersion": "Das Frontend basiert auf dem commit {{commit}} und läuft mit Version {{version}}.",
            "madeWithLove": "Mit ❤️ gemacht von uns, für uns",
            "versionNumber": "Versionsnummer",
            "usedVersions": "Verwendete Versionen",
            "changelog": "Änderungsverzeichnis"
        }
    }
}
